'use strict';

import { ClearRefinements, connectStateResults } from 'react-instantsearch-dom';

export default connectStateResults(props => {
	const { searchState, searchResults } = props;
	
	if (searchResults && searchResults.nbHits !== 0) {
		return null;
	}
	
	if (searchState.query && '' !== searchState.query) {
		return (
			<div>
				<p className="lead">
					Sorry, but we couldn't find any courses matching the phrase
					&ldquo;<strong>{ searchState.query }</strong>&rdquo; and
					your selected filters.
				</p>
				<p className="p-1 my-4 rounded border border-gray-200 border-solid">
					<ClearRefinements translations={ { reset: `Reset all filters and just search for "${ searchState.query }"` } } />
					<ClearRefinements clearsQuery={ true } translations={ { reset: `Start new search` } } />
				</p>
			</div>
		);
	}
	
	return (
		<div>
			<p className="lead">
				Sorry, but we couldn't find any courses your selected filters.
			</p>
			<p className="p-1 my-4 rounded border border-gray-200 border-solid">
				<ClearRefinements clearsQuery={ true } translations={ { reset: `Start new search` } } />
			</p>
		</div>
	);
});
